Dell = window.Dell || {};
Dell.Types = Dell.Types || {};
Dell.OnlineUtils = Dell.OnlineUtils || {};

//(function () {
Dell.Types.SupportHomepage.prototype.handleCoveoSearchQuery = function () {
    var searchInput = Dell.Types.SupportHomepage.prototype.getSearchQuery();
    console.log('Masthead Search text : ' + searchInput);

    var inputData = Dell.Types.SupportHomepage.prototype.getValidateEntityApiInput();

    var request = $.ajax({
        url: Dell.OnlineUtils.AppSettings.Search.ValidateEntityApiUri,
        method: "POST",
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(inputData)
    });

    request.done(function (response) {


        if (response) {
            try {
                var isJsonResponse = Dell.Types.SupportHomepage.prototype.isJSONObject(response);
                var isRedirectionMultipleMatch = Dell.Types.SupportHomepage.prototype.CheckMasteHeadObject(Dell.OnlineUtils.AppSettings.Search.isRedirectionMultipleMatch);
                Dell.Types.SupportHomepage.prototype.MultipleMatchRedirection(response, isRedirectionMultipleMatch);
                if (!isRedirectionMultipleMatch && isJsonResponse === false) {
                    if (response && response.indexOf("mastheadMultiSelectionModel") !== -1) {
                        $('#mastheadMultipleEntityMatchContainer').html(response);

                        $("#mastheadMultipleEntityMatchModal").modal({
                            backdrop: 'static',
                            keyboard: false
                        }).appendTo('body');
                    }
                    else {
                        Dell.Types.SupportHomepage.prototype.redirectToCoveoSearchPage();
                    }
                }
                else if (response && response.EntrySelectionType && response.EntrySelectionType !== '0' && response.LookupResults && response.LookupResults.length > 0) {
                    Dell.Types.SupportHomepage.prototype.handleRedirect(response.LookupResults);
                }
                else {
                    if (typeof (Storage) !== "undefined") {
                        sessionStorage.IsEntityValidationPerformed = true;
                    }
                    Dell.Types.SupportHomepage.prototype.redirectToCoveoSearchPage();
                }
            } catch (e) {
                console.log('Dell.Types.SupportHomepage.prototype.handleCoveoSearchQuery.Done failed with exp : ' + e);
                Dell.Types.SupportHomepage.prototype.redirectToCoveoSearchPage();
            }
        }
    });

    request.fail(function (jqXHR, textStatus) {
        console.log("Request failed for Dell.Types.SupportHomepage.prototype.handleCoveoSearchQuery.ValidateEntrySelection: " + textStatus);
        Dell.Types.SupportHomepage.prototype.redirectToCoveoSearchPage();
    });
};

Dell.Types.SupportHomepage.prototype.CheckMasteHeadObject = function (MastHeadObject) {
    var flag = (MastHeadObject == undefined || MastHeadObject == null || MastHeadObject == '') ? false : true;
    return flag;
};

Dell.Types.SupportHomepage.prototype.MultipleMatchRedirection = function (response, IsRedirectionMultipleMatch) {
    if (IsRedirectionMultipleMatch != undefined && IsRedirectionMultipleMatch && response) {
        if (typeof (Storage) !== "undefined") {
            sessionStorage.setItem("multiplematch_response", JSON.stringify(response));
            sessionStorage.IsEntityValidationPerformed = true;
        }
    }
};


Dell.Types.SupportHomepage.prototype.getValidateEntityApiInput = function () {

    var inputData = {
        "captchaModel": {
            "CaptchaId": "",
            "CaptchaInstanceId": null,
            "CaptchaInput": "",
            "RecaptchaResponse": "",
            "captchaType": "invisible"
        },
        Selection: Dell.Types.SupportHomepage.prototype.getSearchQuery(),
        appName: 'mastheadSearch',
        Ach: Dell.OnlineUtils.AppSettings.Search.IsAssetSearchEnabled,
        Sch: Dell.OnlineUtils.AppSettings.Search.IsSrSearchEnabled,
        Kch: Dell.OnlineUtils.AppSettings.Search.IsKeyWordSearchEnabled
    };

    return inputData;
};

Dell.Types.SupportHomepage.prototype.isScriptLoaded = function (url) {
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length; i--;) {
        if (scripts[i].src == url) return true;
    }
    return false;
};

Dell.Types.SupportHomepage.prototype.isJSONObject = function (response) {
    var isValidJson = false;
    try {
        if (response && response.EntrySelectionType !== undefined)
            isValidJson = true;
    } catch (e) {
        console.log("Masthead isJSONObject function failed.");//Supress exception
    }
    return isValidJson;
};

Dell.Types.SupportHomepage.prototype.handleRedirect = function (data) {
    var url = data[0].TargetUrl;

    try {
        var redirectionType = "";
        switch (data[0].EsubType) {
            case 1:
                redirectionType = 'serviceTag';
                break;
            case 2:
                redirectionType = 'expressServiceCode';
                break;
            case 3:
                redirectionType = 'PSNT';
                break;
            case 4:
                redirectionType = 'serialNumber';
                break;
            case 5:
                redirectionType = 'serviceRequestNumber';
                break;
            case 6:
                redirectionType = 'Article';
                break;
            case 8:
                redirectionType = 'DriverId';
                break;

            default:
                redirectionType = 'None';
                break;
        }

        redirectionType = redirectionType + ':' + Dell.Types.SupportHomepage.prototype.getSearchQuery();
        if (redirectionType.indexOf("DriverId") > -1) {
            dellmetricsTrack_prop13_coveo_format(redirectionType);
        }
        else if (redirectionType.indexOf("Article") > -1) {
            dellmetricsTrack_prop13_coveo_format(redirectionType);
        }

        dellmetricsTrack_prop20_format("111.300.200.002", redirectionType);
    }
    catch (e) {
        console.log("Exception in Dell.Types.SupportHomepage.prototype.handleRedirect : " + url);
    }

    console.log("Dell.Types.SupportHomepage.prototype.handleRedirect : " + url);
    SecureRedirectUrl(url, false);
};

function dellmetricsTrack_prop13_coveo_format(value) {
    Dell.Metrics.sc.pagename = (Dell.Metrics.sc.country +
        '|' +
        Dell.Metrics.sc.language +
        '|' +
        Dell.Metrics.sc.segment +
        '|' +
        Dell.Metrics.sc.customerset +
        "|coveo|docsearchresults|" +
        '|' +
        value);
}

Dell.Types.SupportHomepage.prototype.redirectToCoveoSearchPage = function () {
    Dell.Types.SupportHomepage.prototype.setSearchProgressAction(false);
    var searchString = Dell.Types.SupportHomepage.prototype.getSearchQuery();
    var searchUrl = Dell.Supportpage.Urls.SupportSearch.RedirectUrl + "#q=" + encodeURIComponent(searchString) + (Dell.Supportpage.getNewHash().length > 0 ? Dell.Supportpage.getNewHash() : "");
    console.log("Dell.Types.SupportHomepage.prototype.redirectToCoveoSearchPage called with url :" + searchUrl);
    SecureRedirectUrl(searchUrl);
};

Dell.Types.SupportHomepage.prototype.getSearchQuery = function () {
    var searchInput;
    if ($(Dell.Supportpage.Constants.Selectors.SEARCH_INPUT).is(":visible"))
        searchInput = $(Dell.Supportpage.Constants.Selectors.SEARCH_INPUT).val().trim();
    else
        searchInput = $(Dell.Supportpage.Constants.Selectors.SEARCH_INPUT_MOB).val().trim();
    return searchInput.replace(/</g, '').replace(/>/g, '');
};

Dell.Types.SupportHomepage.prototype.setSearchProgressAction = function (isProcessing) {
    if (isProcessing) {
        if ($(Dell.Supportpage.Constants.Selectors.SEARCH_INPUT_MOB).is(":visible")) {
            $(Dell.Supportpage.Constants.Selectors.SEARCH_FORM_MOB).find('button').css("display", "none");
            $(Dell.Supportpage.Constants.Selectors.SEARCH_FORM_MOB).find('span').css("display", "");
        }
        else {
            $(Dell.Supportpage.Constants.Selectors.SEARCH_FORM).find('button').css("display", "none");
            $(Dell.Supportpage.Constants.Selectors.SEARCH_FORM).find('span').css("display", "");
        }
    }
    else {
        if ($(Dell.Supportpage.Constants.Selectors.SEARCH_INPUT_MOB).is(":visible")) {
            $(Dell.Supportpage.Constants.Selectors.SEARCH_FORM_MOB).find('button').css("display", "").next('span').css("display", "none");
        }
        else {
            $(Dell.Supportpage.Constants.Selectors.SEARCH_FORM).find('button').css("display", "").next('span').css("display", "none");
        }
    }
};

function mastheadMultiSelection(eSubType) {
    Dell.Types.SupportHomepage.prototype.setSearchProgressAction(false);

    if (eSubType !== undefined && eSubType === "Article") {
        if (typeof (Storage) !== "undefined") {
            sessionStorage.IsEntityValidationPerformed = true;
        }
        $('#mastheadMultipleEntityMatchModal').modal('hide');
        event.preventDefault();
        Dell.Types.SupportHomepage.prototype.redirectToCoveoSearchPage(true);
    }
}

function mastheadCloseMultiSelectionModel() {
    Dell.Types.SupportHomepage.prototype.setSearchProgressAction(false);
}

$(document).on("keydown", "#search-input, #search-input-mob", (function (e) {
    if ((e.which == 38 || e.which == 40) && $("#ui-active-menuitem") !== undefined && $("#ui-active-menuitem")[0] !== undefined) {
        $("#search-input").val($("#ui-active-menuitem")[0].innerText);
    }
}));

//})();


function dellmetricsTrack_prop20_format(appcode, tabname) {
    if (typeof (dellmetricsTrack) === "function") {
        if (dellmetricsTrack) {
            dellmetricsTrack(appcode, tabname);
        }
    }
}
